import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {accountUserActions} from "app/accountLoginSlice";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {setGroups, setGroupsError} from "../../slice/groups/groupsSlice";
import {GroupApiResponse} from "features/model/types/groups/groupsSchema";

export const fetchGroups = createAsyncThunk(
    "groups/fetchGroups",
    async (_, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);
            const response = await axios.get<GroupApiResponse>("/api/groups", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.data) {
                throw new Error("Response data is empty");
            }

            if (response.data.success) {
                thunkAPI.dispatch(accountUserActions.accountUser());
            }

            thunkAPI.dispatch(setGroups(response.data));
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                thunkAPI.dispatch(setGroupsError(error.response.status));
            } else {

                thunkAPI.dispatch(setGroupsError(500));
            }
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);